import ReactGA from "react-ga4";
import mixpanel from "mixpanel-browser";

export const eventCategories = {
  play: {
    round: {
      start: "competition_round_start",
      complete: "competition_round_complete",
      giveUp: "competition_round_give_up",
    },
    hint: {
      reveal: "reveal_hint",
    },
    guess: {
      submit: "submit_guess",
    },
    game: {
      start: "competition_game_start",
      complete: "competition_game_complete",
      rating: {
        positive: "competition_game_rating_positive",
        negative: "competition_game_rating_negative",
      },
    },
  },
};

export const analyticsInit = (
  measurementId: string,
  mixpanelToken?: string
) => {
  if (window.location.hostname !== "localhost") {
    ReactGA.initialize(measurementId);
    if (mixpanelToken) {
      mixpanel.init(mixpanelToken, {
        // Events go to our own API, which passes them on to Mixpanel, so
        // ad blockers that block Mixpanel's domain do not drop them.
        api_host: `${import.meta.env.VITE_API_BASE_URL}/mp/api`,
        debug: window.location.hostname === "localhost",
        track_pageview: "url-with-path",
        persistence: "localStorage",
      });
    }
  } else {
    console.log(
      `[Analytics] Initialized with measurementId: ${measurementId} and mixpanelToken: ${mixpanelToken}`
    );
  }
};

export const identify = (id: string) => {
  if (window.location.hostname !== "localhost") {
    ReactGA.set({ userId: id });
    mixpanel.identify(id);
  } else {
    console.log("[Analytics] Identified User:", id);
  }
};

// Utility function to track page views
export const logPageView = () => {
  if (window.location.hostname !== "localhost") {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  } else {
    console.log("[Analytics] PageView:", window.location.pathname);
  }
};

// Optional: Utility function to track custom events
export const logEvent = (category: string, action?: string) => {
  let eventAction = action
    ? `${category}_${action.toLowerCase().replace(" ", "_").replace(".", "")}`
    : category;

  if (window.location.hostname !== "localhost") {
    ReactGA.event({
      category,
      action: eventAction,
    });
  } else {
    console.log("[Analytics] Event:", { category, action: eventAction });
  }
};

export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  if (window.location.hostname !== "localhost") {
    mixpanel.track(eventName, properties);
  } else {
    console.log("[Analytics] TrackEvent:", { eventName, properties });
  }
};

// Sets properties on the player's Mixpanel profile.
export const setProfileProperties = (
  properties: Record<string, string | number | boolean | null>
) => {
  if (window.location.hostname !== "localhost") {
    mixpanel.people.set(properties);
  } else {
    console.log("[Analytics] Set Profile Properties:", properties);
  }
};

export const incrementProfileProperty = (
  property: string,
  amount: number = 1
) => {
  if (window.location.hostname !== "localhost") {
    mixpanel.people.increment(property, amount);
  } else {
    console.log("[Analytics] Increment Profile Property:", {
      property,
      amount,
    });
  }
};
